import React, { memo, useEffect, useCallback, useRef, useState, useMemo, } from 'react';
import classnames from 'classnames/bind';
import { ButtonLink, Text, NavigationDeleteCircleIcon, } from '@wildberries/ui-kit';
import { notificationStatus } from '../../../../../../constants';
import { NotificationsIcon } from '../notification-icon';
import styles from './index.scss';
var cn = classnames.bind(styles);
var BLOCK_NAME = 'Notification-modal';
export var NotificationsModal = memo(function (_a) {
    var _b, _c;
    var closeModal = _a.closeModal, id = _a.id, title = _a.title, text = _a.text, status = _a.status, timeToHold = _a.timeToHold, externalAction = _a.externalAction, additionalActionType = _a.additionalActionType, additionalPayload = _a.additionalPayload, externalContent = _a.externalContent, disabledClose = _a.disabledClose, isClosing = _a.isClosing;
    var notificationModalRef = useRef(null);
    var _d = useState({
        isOut: false,
        direction: null,
    }), state = _d[0], setState = _d[1];
    var isLeftFadeOut = useMemo(function () { return state.isOut && state.direction === 'left-out'; }, [state.direction, state.isOut]);
    var isRightFadeOut = useMemo(function () { return state.isOut && state.direction === 'right-out'; }, [state.direction, state.isOut]);
    useEffect(function () {
        if (Boolean(notificationModalRef.current)) {
            var modalComputedStyles = getComputedStyle(
            // eslint-disable-next-line
            // @ts-ignore
            notificationModalRef.current);
            var modalHeight = Number(modalComputedStyles.getPropertyValue('height').slice(0, -2));
            var modalMarginTop = Number(modalComputedStyles.getPropertyValue('margin-top').slice(0, -2));
            var modalMarginBottom = Number(modalComputedStyles.getPropertyValue('margin-bottom').slice(0, -2));
            var modalPaddingTop = Number(modalComputedStyles.getPropertyValue('padding-top').slice(0, -2));
            var modalPaddingBottom = Number(modalComputedStyles.getPropertyValue('padding-bottom').slice(0, -2));
            // to make the isomorphic component
            if (document) {
                document.documentElement.style.setProperty('--notification-max-height', "".concat(modalHeight +
                    modalMarginTop +
                    modalMarginBottom +
                    modalPaddingTop +
                    modalPaddingBottom +
                    5, "px"));
            }
        }
        var timer = setTimeout(function () {
            setState({
                isOut: true,
                direction: 'right-out',
            });
            closeModal(id);
        }, timeToHold);
        return function () { return clearTimeout(timer); };
    }, []); //eslint-disable-line
    useEffect(function () {
        if (isClosing) {
            setState({
                isOut: true,
                direction: 'right-out',
            });
            closeModal(id);
        }
    }, [closeModal, id, isClosing]);
    var touchFromX = 0;
    var touchToX = 0;
    var onCloseModal = useCallback(function (isDirectionLeft) {
        if (additionalActionType && externalAction) {
            externalAction({ id: id, additionalActionType: additionalActionType, additionalPayload: additionalPayload });
        }
        setState({
            isOut: true,
            direction: isDirectionLeft ? 'left-out' : 'right-out',
        });
        closeModal(id);
    }, [additionalActionType, additionalPayload, closeModal, externalAction, id]);
    var handleCloseClick = useCallback(function () {
        setState({
            isOut: true,
            direction: 'right-out',
        });
        onCloseModal(false);
    }, [onCloseModal]);
    var trackDeltaTouchMove = useCallback(function () {
        var isDirectionLeft = touchFromX > touchToX;
        var delta = Math.abs(touchFromX - touchToX);
        if (delta > 60 && !disabledClose) {
            onCloseModal(isDirectionLeft);
        }
    }, [disabledClose, onCloseModal, touchFromX, touchToX]);
    var handleTouchStart = useCallback(function (_a) {
        var touches = _a.touches;
        touchFromX = touches[0].clientX; //eslint-disable-line
    }, []);
    var handleTouchEnd = useCallback(function (_a) {
        var changedTouches = _a.changedTouches;
        touchToX = changedTouches[0].clientX; //eslint-disable-line
        trackDeltaTouchMove();
    }, []);
    return (React.createElement("div", { className: cn(BLOCK_NAME, (_b = {},
            _b["".concat(BLOCK_NAME, "--success")] = status === notificationStatus.success,
            _b["".concat(BLOCK_NAME, "--error")] = status === notificationStatus.error,
            _b["".concat(BLOCK_NAME, "--warning")] = status === notificationStatus.warning,
            _b["".concat(BLOCK_NAME, "--no-text")] = !text,
            _b["".concat(BLOCK_NAME, "--exit-left")] = isLeftFadeOut,
            _b["".concat(BLOCK_NAME, "--exit-right")] = isRightFadeOut,
            _b)), onTouchStart: handleTouchStart, onTouchEnd: handleTouchEnd, ref: notificationModalRef },
        React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__info-icon")) },
            React.createElement(NotificationsIcon, { status: status })),
        React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__content")) },
            title && (React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__title"), (_c = {},
                    _c["".concat(BLOCK_NAME, "__title--no-text")] = !text,
                    _c)) },
                React.createElement(Text, { text: title, size: "h2", color: "black", whiteSpace: "pre-wrap" }))),
            text && (React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__text")) },
                React.createElement(Text, { text: text, size: "h4", color: "black", whiteSpace: "pre-wrap" }))),
            Boolean(externalContent) && (React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__external-content")) }, externalContent))),
        !disabledClose && (React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__close-button")) },
            React.createElement(ButtonLink, { onClick: handleCloseClick, size: "small", type: "button", variant: "only-icon" }, NavigationDeleteCircleIcon)))));
});
